import { Pipe, PipeTransform } from '@angular/core';
import { convert24hTimeToAmPm } from '@app/utils/date';

@Pipe({ name: 'plTwentyFourHoursToAmPm' })
export class TwentyFourHoursToAmPmPipe implements PipeTransform {
  public transform(timeToConvert: string | null): string {
    return convert24hTimeToAmPm(timeToConvert);
  }
}
